import { reactive, toRefs } from "vue";

interface SavePopupResult {
  workspace?: number;
  folder?: number;
  folderSlug?: string;
  name: string;
  author?: string;
  password?: string;
}

interface SavePopup extends SavePopupResult {
  visible: boolean;
  authorEditable: boolean;
  showWorkspaceFolderInput: boolean;
  usePassword: boolean;
  isSimulationGame: boolean;
  asFileExport: boolean;
}

const savePopup: SavePopup = reactive({
  visible: false,
  name: "",
  isSimulationGame: false,
  author: undefined,
  authorEditable: false,
  usePassword: false,
  password: undefined,
  workspace: undefined,
  folder: undefined,
  folderSlug: undefined,
  showWorkspaceFolderInput: true,
  asFileExport: false
});

const resolvers: {
  resolve: null | ((_value: SavePopupResult) => void);
  reject: null | (() => void);
} = {
  resolve: () => {},
  reject: () => {}
};

export function useSavePopup() {
  function openSavePopup(
    data: {
      name?: string;
      workspace?: number;
      folder?: number;
      folderSlug?: string;
      isSimulationGame?: boolean;
      author?: string | null;
      password?: string;
    } = {},
    { asFileExport = false, showWorkspaceFolderInput = true } = {}
  ): Promise<SavePopupResult> {
    Object.assign(savePopup, data);

    savePopup.authorEditable = data.author == null;
    savePopup.visible = true;

    savePopup.asFileExport = asFileExport;
    savePopup.showWorkspaceFolderInput = showWorkspaceFolderInput;

    return new Promise((resolve, reject) => {
      resolvers.resolve = resolve;
      resolvers.reject = reject;
    });
  }

  async function submit() {
    savePopup.visible = false;

    const data: SavePopupResult = {
      name: savePopup.name,
      workspace: savePopup.workspace,
      folder: savePopup.folder,
      folderSlug: savePopup.folderSlug
    };
    if (savePopup.usePassword) {
      data.password = savePopup.password;
    }
    if (savePopup.author) {
      data.author = savePopup.author;
    }

    resolvers?.resolve?.(data);
    resolvers.resolve = null;
    resolvers.reject = null;
  }

  function cancelSave() {
    savePopup.visible = false;

    resolvers?.reject?.();
    resolvers.resolve = null;
    resolvers.reject = null;
  }

  return {
    ...toRefs(savePopup),
    openSavePopup,
    submit,
    cancelSave
  };
}
